import React from 'react';
import { PlacesType } from 'react-tooltip';

import { TOOLTIP_ROOT_ID } from './GlobalTooltipRoot';

type CustomTooltipProps = {
  placement: PlacesType;
  message?: string;
  wrapperStyle?: React.CSSProperties;
};

function CustomTooltip({ placement, message, wrapperStyle, children }: React.PropsWithChildren<CustomTooltipProps>) {
  if (!message) return <>{children}</>;

  return (
    <span
      data-testid="custom-tooltip"
      data-tooltip-id={TOOLTIP_ROOT_ID}
      data-tooltip-place={placement}
      // `message` may contain HTML (e.g. <br>, <ul>). It is sanitized at the
      // single injection boundary in GlobalTooltipRoot's `render`, so it is
      // stored raw here.
      data-tooltip-html={message}
      style={wrapperStyle}
    >
      {children}
    </span>
  );
}

export default CustomTooltip;
